module.exports = __webpack_public_path__ + "static/media/share-ideas.bb6fea23.png";